import Assets from "mpm-assets";
import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Divider, Grid, Icon, Image } from "semantic-ui-react";

function Unautorized(props) {
  let history = useHistory();
  history.push("/");

  return (
    <div className="unauthorized">
      <Grid   textAlign="left" verticalAlign="middle">
        <Grid.Column width="9">
            <h1>Accès non autorisé</h1>
            <p>Désolé, vous n’êtes pas autorisé à accéder à cette page.</p>
          <Divider />
          <Button icon labelPosition="left" onClick={() => props.history.goBack()}>
            <Icon name="chevron left"></Icon>
            Retour
          </Button>
        </Grid.Column>
        <Grid.Column width="7" textAlign="center" verticalAlign="middle">
          <Image src={Assets.Images.unautorized} size="massive" /> 
        </Grid.Column>
      </Grid>
    </div>
  );
}

export default Unautorized;
